<template>
    <el-dialog :visible.sync="dialogVisible" title="选择指标" custom-class="custom-dialog" :close-on-click-modal="false"
                @opened="dialogOpen" @closed="dialogClose" width="590px" append-to-body>
        
        <div style="display: inline-block; height:40px;">
            <el-select v-model="queryForm.evaluateTypeId"  clearable placeholder="请选择五育评价" style="width:200px;">
                <el-option
                    v-for="item in evaluateTypes"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
            </el-select>
        </div>
        <div style="display: inline-block; height:40px;">
            <el-select v-model="queryForm.type" placeholder="请选择评价类型" style="width:200px;">
                <el-option
                    v-for="item in types"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
        </div>
        <el-button type="primary" icon="search" @click="getData()">查询</el-button>
        <div style="display: inline-block; height:40px; float: right;">
            <el-button type="primary"  @click="add()">确定</el-button>
        </div>

        <el-table
            :data="data"
            style="width: 100%;margin-bottom: 20px;"
            row-key="id"
            v-loading="loading"
            height="350"
            :default-expand-all="true"
            element-loading-background = "rgba(255, 255,255,0.7)"
            element-loading-text = "数据正在加载中..."
            border
            fit highlight-current-row
            @row-click="handleSelectionChange">
            <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
            <el-table-column prop="title" label="指标名称"  :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="score" label="分数值"  width="80"></el-table-column>
        </el-table>
    </el-dialog>
</template>

<script>
    import http from '../../../../common/http';

    export default {
        name: 'setEvaluateIndex',
        components: {},
        props: {
            value: Boolean,
            deptId: {
                type: String,
                default() {
                    return ""
                }
            },
        },
        watch: {
            value(val) {
                this.dialogVisible = val
            },
            dialogVisible(val) {
                this.$emit('input', val)
            },
        },
        data(){
            return{
                loading:false,
                dialogVisible:false,
                queryForm:{
                    id:"",
                    evaluateTypeId:"",
                },
                form:{
                    id:"",
                    title:"",
                },
                data:[],
                evaluateTypes:[],
                types:[{
                    value: 1,
                    label: '表扬'
                },{
                    value: 2,
                    label: '待改进'
                }]
            }
        },
        created:function () {
        },
        methods:{
            indexMethod(index) {
                return (index+1);
            },
            dialogOpen() {
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields()
                }
                // 初始值
                this.evaluateTypes= []
                this.queryForm.type = 1
                
                this.getEvaluateType()
                this.getData()
            },
            dialogClose(){
                this.dialogVisible = false
            },
            // 获取五育评价类型
            getEvaluateType(){
                let url= this.evaluateTypeListUrl
                let data = {
                    deptId:this.deptId,
                }
                this.apiPost(url, data).then((res) => {
                    if(res.status === 200){
                        this.evaluateTypes=res.data.list
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                }, (err) => {
                    console.log(err);
                });
            },
            getData(){
                let url  = this.evaluateIndicatorsDefineModuleEvaluateIndexUrl
                let data = {
                    deptId: this.deptId,
                    moduleTitle: "实践评价",
                    evaluateTypeId: this.queryForm.evaluateTypeId,
                };
                // console.log(data);
                this.loading=true
                this.apiPost(url,data).then((res) => {
                    if(res.status === 200){
                       if(this.queryForm.type === 1){
                            this.data = res.data.praiseIndicators
                       }else if(this.queryForm.type === 2){
                            this.data = res.data.improvedIndicators
                       }
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                    this.loading=false
                },(err)=>{
                    console.log(err)
                    this.loading=false
                });
            },
            handleSelectionChange(row, column, event){
                this.form.id=row.id
                this.form.title=row.title

            },
            add(){
                console.log('id',this.form.id,'title',this.form.title)
                if(this.$util.isEmpty(this.form.id)){
                    this.$commonFn.showTip('请选择指标',3)
                    return
                }
                this.$parent.setEvaluate(this.form.id,this.form.title)
                this.dialogVisible=false;
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/task/components/setEvaluateIndex.vue